<template>
  <Components />
</template>

<script>
import Components from "./components/Components";

export default {
  name: "App",
  components: {
    Components
  },
  data: () => ({
    //
  })
};
</script>
<style lang="scss">
@import "scss/application.scss";
</style>